import { render, staticRenderFns } from "./creat_by_bl.vue?vue&type=template&id=14410f90&scoped=true&"
import script from "./creat_by_bl.vue?vue&type=script&lang=js&"
export * from "./creat_by_bl.vue?vue&type=script&lang=js&"
import style0 from "./creat_by_bl.vue?vue&type=style&index=0&id=14410f90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14410f90",
  null
  
)

export default component.exports